import * as designsEntitiesTypes from "state/entities/designs/designsTypes";
import { isEmpty, omit, getPath } from "lib/lodash";

export const sizeInitState = {
  pages: {},
  totalCount: null,
  pageSize: 50
};

export const initState = {};

const templatesApiReducers = (state = initState, action) => {
  switch (action.type) {
    case designsEntitiesTypes.PURCHASED_TEMPLATES_DESIGNS_REQUEST: {
      const sizeName = action.request.params.size || "all";
      const currentState = state[sizeName] || initState;

      const { page } = action.request;
      return {
        ...state,
        [sizeName]: {
          pages: {
            ...currentState.pages,
            [page]: {
              ...getPath(currentState, `pages.${page}`, {}),
              isFetching: true
            }
          },
          totalCount: null,
          pageSize: 50
        }
      };
    }

    case designsEntitiesTypes.PURCHASED_TEMPLATES_DESIGNS_REQUEST_SUCCESS: {
      const {
        response: { ids = [] } = {},
        request: { page, params }
      } = action;

      const sizeName = params.size || "all";

      if (isEmpty(ids) && Number(page) !== 1) {
        return {
          ...state,
          [sizeName]: {
            ...state[sizeName],
            pages: omit(state.pages, action.request.page)
          }
        };
      }

      const updatedPage = {
        [page]: {
          isFetching: false,
          ids: ids,
          didInvalidate: false
        }
      };

      return {
        ...state,
        [sizeName]: {
          ...state[sizeName],
          pages: { ...state[sizeName].pages, ...updatedPage }
        }
      };
    }

    default:
      return state;
  }
};

export default templatesApiReducers;
